<template>
    <div class="cropzoomimg-container"
         v-bind:style="{height:properHeight}"
         :aspect-ratio="aspectRatio">

        <dvidsVideo v-if="isDvids" :slideId="slide.slideId" :videoObj="videoObj" :portalId="portalId"></dvidsVideo>

        <youTubeVideo v-if="isYouTube" :slideId="slide.slideId" :videoId="videoId"></youTubeVideo>

        <hoverOverlayLink v-if="!isVideo"
                          :title="overlaytitle"
                          :data="data"
                          :href="slideLink"
                          :showOverlay="clickCallback?true:false"
                          :clickCallback="handleClick"
                          :iconRender="renderOverlayClassIcons">
            <div v-if="useOverlay" class="video-overlay"></div>
            <img class="cropzoomimg-img"
                 v-bind:class="imgClasses"
                 alt=""
                 ref="mainImage"
                 :actualAspectRatio="imgAspectRatio"
                 :src="src" />
        </hoverOverlayLink>
    </div>
</template>

<script>
    import dotGet from 'lodash/get';
    import hoverOverlayLink from './hoverOverlayLink.vue';
    import dvidsVideo from './dvidsVideo.vue';
    import youTubeVideo from './youtubeVideo.vue';
    const DEBUG=false;
    export default {
        name: 'cropzoomimg',
        props: {
            src: String,
            aspectRatio: Number,
            title: String,
            clickCallback: Function,
            data: Object,
            debug: {
                type: Boolean,
                default: false
            },
            alt: {
                type: String,
            },
            slide: Object,
            portalId: String,
        },
        components: {
            hoverOverlayLink,
            dvidsVideo,
            youTubeVideo
        },
        data: function() {
            return {
                imgAspectRatio: 1,
                imgNaturalHeight: 0,
                imgNaturalWidth: 0,
                properHeight: "100%",
            };
        },
        computed: {
            imgClasses: function() {
                if(DEBUG) console.log('cz55: ars',this.src,this.imgAspectRatio,this.$props.aspectRatio);
                return {
                    cropzoomFillHeight: this.imgAspectRatio>=this.$props.aspectRatio,

                }
            },
            isDvids: function() {
                if(!this.$props.slide) return false;
                return !!this.$props.slide.isDvids;
            },
            isYouTube: function() {
                if(!this.$props.slide) return false;
                return !!this.$props.slide.isYoutube;
            },
            videoObj: function() {
                if(!this.$props.slide) return {};
                if(!this.slide.videoObj) return {};
                return this.slide.videoObj.results;
            },
            isVideo: function() {
                if(!this.$props.slide) return false;
                return !!this.$props.slide.isVideo;
            },
            renderOverlayClassIcons: function () {
                if(this.$props.data?.isVideo) return 'fa-brands fa-youtube';
                return 'fas fa-search-plus';
            },
            videoId: function() {
                if(!this.$props.slide) return '';
                if(!this.slide.videoId) return '';
                return this.slide.videoId;
            },
            slideLink: function() {
                if(!this.$props.slide) return undefined;
                if(!this.slide.link) return undefined;
                return this.slide.link;
            },
            useOverlay: function() {
                if(!this.$props.slide) return false;
                return !!this.$props.slide.useOverlay;
            },
            overlaytitle: function () {
                if(this.$props.data?.isVideo) return 'Play Video';
                return this.$props.title;
            }
        },
        methods: {
            handleClick: function(event,data) {
                if(DEBUG) console.log("cz58: cropzoom handleClick",event,data);
                if(this.$props.clickCallback) {
                    this.$props.clickCallback(event,data);
                }
            },
            handleCurrentSize: function() {
                this.$nextTick(() => {
                    const divWidth=this.$el.offsetWidth;
                    const divHeight=this.$el.offsetHeight;
                    const divRealAspect=divWidth/divHeight;
                    let properHeight=divWidth/this.$props.aspectRatio;

                    if(DEBUG) {
                        console.log("d2p68: cropzoom handle current size (debug)",
                            {
                                propsAspectRatio: this.$props.aspectRatio,
                                imgAspectRatio: this.imgAspectRatio,
                                divRealAspect,
                                divWidth,divHeight,properHeight,
                            });
                    }
                    //properHeight = Math.max(properHeight, divHeight);

                this.properHeight = `${properHeight}px`;
            });
        }
    },
    // Life Cycle
    created: function () {
        window.addEventListener('resize', () => this.handleCurrentSize());
    },

        mounted: function() {
            /* load listener and handleCurrent below is and example where arrow functions,
             using "=>" are useful, because it uses 'this'. We expect
             'this' to point to the current Vue component we are in now,
             but if it was declared "function () {...}" it would get its
             own this (would be window or something, depending on caller);
            */
            if(this.$refs.mainImage) {
                this.$refs.mainImage.addEventListener("load",() => {
                    const imH=dotGet(this.$refs,"mainImage.naturalHeight",-1);
                    const imW=dotGet(this.$refs,"mainImage.naturalWidth",-1);
                    this.imgNaturalHeight=imH;
                    this.imgNaturalWidth=imW;
                    this.imgAspectRatio=imW/imH;
                    this.handleCurrentSize();
                });
            }


            //this.$nextTick( () => this.handleCurrentSize() );
        },
    };
</script>

<style lang="scss">
    .cropzoomimg-container {
        position: relative;
        overflow: hidden;
        margin: 0 auto 0;
    
    .video-overlay
    {
        height: 46px;
        width: 66px;
        background: url('/Portals/_default/Skins/DGOV2/Resources/img/play-default.png');
        z-index: 1000;
        background-size:cover;
        }

    .video-overlay:hover {
        background-image: url('/Portals/_default/Skins/DGOV2/Resources/img/play-default.png');
        background-size: cover;
    }

    &:hover {
        .video-overlay

    {
        background-image: url('/Portals/_default/Skins/DGOV2/Resources/img/play-hover.png');
    }
    }

    .cropzoomimg-img {
        //transition: all 0.25s ease-in-out;
        position: absolute;
        width: 100%;
        max-width: 100%;
        height: auto;
        max-height: none;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        transition: none;
        &.cropzoomFillHeight

    {
        width: auto;
        max-width: none;
        height: 100%;
        max-height: 100%;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
    }

    }
    }
</style>
